<template>
    <div class="wrapper-bg">
        <div class="main-layout coffee">
            <HeaderOther
                setTitle="รายละเอียดแพ็กเก็จ"
                :setHref="'subscriptionform'"
                :showLogo="false"
            />
            <div class="packageDetail-main">
                <div class="packageDetail-container">
                    <div class="location-container">
                        <LocationDropdown
                            path="packagedetail"
                            :showStar="true"
                        />
                    </div>
                    <div class="input-container">
                        <div class="input-header">
                            Day<span class="red-star">*</span>
                        </div>
                        <div class="input-wrapper">
                            <div
                                class="radio-container"
                                v-for="(item, index) in checkboxList"
                                :key="index"
                                @click="toggleCheckbox(index)"
                            >
                                <img
                                    v-if="item.active"
                                    src="@/assets/campaignlist/checkmenu_active.svg"
                                    alt=""
                                />
                                <img
                                    v-else
                                    src="@/assets/campaignlist/checkmenu_inactive_outline.svg"
                                    alt=""
                                />
                                <div class="radio-text">{{ item.name }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="datepicker-wrapper">
                        <DatePicker
                            title="Start date"
                            v-model="datePicker"
                            @setStartDate="checkValidate"
                        />
                    </div>
                    <div class="input-container">
                        <div class="input-header">
                            My coffee will run out on
                        </div>
                        <div class="expire-container">
                            <img
                                class="datepicker-icon"
                                src="@/assets/campaignlist/carbon_calendar.svg"
                                alt=""
                            />
                            <div class="date-value">{{ expireTime }}</div>
                        </div>
                    </div>
                    <div class="input-container">
                        <div class="input-header">
                            Pick up Time<span class="red-star">*</span>
                        </div>
                        <TimePicker
                            :workingTime="getLocationStore.workingDay"
                            @setStartTime="checkValidate"
                            v-model="timepicker"
                        />
                    </div>
                </div>
            </div>
            <Footer
                layout="black"
                text="เลือก"
                action="validateSubmit"
                path="menu"
                :param="config"
                :validate="validateValue"
                :total="beverageData.totalPrice"
            ></Footer>
        </div>
    </div>
</template>

<script>
import Moment from "moment";
//components
import HeaderOther from "@/components/Header/HeaderOther.vue";
import Footer from "@/module/Subscription/components/Footer.vue";
import LocationDropdown from "@/components/Input/LocationDropdown.vue";
import DatePicker from "@/module/Subscription/components/DatePicker.vue";
import TimePicker from "@/module/Subscription/components/TimePicker.vue";
//vuex
import { mapGetters, mapActions } from "vuex";

export default {
    name: "PackageDetail",
    components: {
        HeaderOther,
        Footer,
        LocationDropdown,
        DatePicker,
        TimePicker
    },
    props: {
        data: Object
    },
    data() {
        return {
            beverageData: {},
            datePicker: "",
            timepicker: "",
            location: this.getLocationStore,
            checkboxList: [
                { name: "Everyday", active: false },
                { name: "Sun.", active: false },
                { name: "Mon.", active: false },
                { name: "Tue.", active: false },
                { name: "Wed.", active: false },
                { name: "Thu.", active: false },
                { name: "Fri.", active: false },
                { name: "Sat.", active: false }
            ],
            config: {
                campaignId: "",
                startDate: "",
                defaultSchedule: "",
                sideCampaignJson: [],
                locationId: ""
            },
            validateValue: false,

            dateValue: "",
            timeValue: "",
        };
    },
    created() {
        this.init();
    },
    computed: {
        ...mapGetters(["getUserSubscription"]),
        ...mapGetters(["getLocationStore"]),
        expireTime: {
            get() {
                if (this.datePicker) {
                    return Moment(this.datePicker, "DD / MMM / YY")
                        .add(1, "months")
                        .format("DD / MMM / YY");
                } else {
                    return "DD / MM / YY"
                }
            }
        }
    },
    methods: {
        ...mapActions(["setUserSubscription"]),
        init() {
            if (!this.data) {
                this.beverageData = this.getUserSubscription.detail.beverage;
            } else {
                this.setUserSubscription({
                    beverage: this.data
                });
                this.beverageData = this.data;
            }
            this.config.campaignId = this.beverageData.defaultCupCode;
            if (this.beverageData.check) {
                for (let i = 0; i < this.beverageData.check.length; i++) {
                    this.config.sideCampaignJson.push(
                        this.beverageData.check[i].id
                    );
                }
            }
            if (this.beverageData.sweetnessCode) {
                this.config.sideCampaignJson.push(this.beverageData.sweetnessCode);
            }
            this.config.campaignId = this.beverageData.defaultCupCode;

            let regEx = new RegExp("\\IC", "gi");

            if (this.getLocationStore.id) {
                this.config.locationId = this.getLocationStore.id.replace(
                    regEx,
                    ""
                );
            }
        },
        toggleCheckbox(index) {
            this.checkboxList[index].active = !this.checkboxList[index].active;

            if (this.checkboxList[0].active && index === 0) {
                for (let i = 1; i < this.checkboxList.length; i++) {
                    this.checkboxList[i].active = true;
                }
                this.config.defaultSchedule = "EveryDay";
                delete this.config.customizeDay
                this.checkValidate();
            }
            if (!this.checkboxList[0].active && index === 0) {
                for (let i = 1; i < this.checkboxList.length; i++) {
                    this.checkboxList[i].active = false;
                }
                this.config.defaultSchedule = "";
                this.checkValidate();
            }
            if (this.checkboxList[0].active && index !== 0) {
                this.checkboxList[0].active = false;
            }
            let isEveryDay = this.checkboxList.filter(item => {
                return item.active === true;
            });
            if (isEveryDay.length === 7) {
                this.checkboxList[0].active = true;
                this.config.defaultSchedule = "EveryDay";
                delete this.config.customizeDay
                this.checkValidate();
            }
            let arraySchedule = ["0", "0", "0", "0", "0", "0", "0", "0"];

            if (!this.checkboxList[0].active) {
                for (let i = 0; i < this.checkboxList.length; i++) {
                    if (this.checkboxList[i].active) {
                        arraySchedule[i] = "1";
                    }
                }
                arraySchedule.push(arraySchedule[1]);
                arraySchedule.splice(0, 2);

                this.config.defaultSchedule = "Customize"
                this.config.customizeDay = arraySchedule.join("");
                this.checkValidate();
            }
        },
        checkValidate(value) {
            if (value && value.name === "date") {
                this.dateValue = value.value;
            }
            if (value && value.name === "time") {
                this.timeValue = value.value.text;
            }
            if (this.timeValue && this.dateValue) {
                this.startDate = `${this.dateValue}T${
                    this.timeValue.split(" : ")[0]
                }:${this.timeValue.split(" : ")[1]}:00`;
            }
            if (this.startDate) {
                this.config.startDate = this.startDate;
            }
            if (
                this.config.campaignId !== "" &&
                this.config.startDate !== "" &&
                this.config.defaultSchedule !== "" &&
                this.config.defaultSchedule !== "0000000" &&
                this.config.locationId !== ""
            ) {
                this.validateValue = true;
            } else {
                this.validateValue = false;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.red-star {
    color: #e1261c;
}
.wrapper-bg {
    padding: 0;
    .packageDetail-main {
        padding: 25px 20px;
        .datepicker-wrapper {
            position: relative;
        }
        .packageDetail-container {
            background-color: #000;
            border-radius: 10px;
            padding: 12px 10px;
        }
    }
}
.location-container {
    margin-bottom: 15px;
}
.input-container {
    .input-header {
        font-size: 14px;
        color: #908276;
    }
    .input-wrapper {
        padding: 10px;
        display: grid;
        grid-template-columns: auto auto auto;
        .radio-container {
            margin-right: 15px;
            margin-bottom: 13px;
            display: flex;
            img {
                margin-right: 12px;
            }
        }
    }
    .input-wrapper :first-child {
        grid-column: 1 / -1;
    }
    .datepicker-ui,
    .expire-container {
        display: flex;
        padding: 10px;
        .datepicker-icon {
            margin-right: 15px;
        }
        .datepicker-value {
            min-width: 66vw;
        }
        .date-value {
            color: #908276;
            font-size: 16px;
        }
    }
    .expire-container {
        padding-bottom: 30px;
    }
}
label {
    margin: 0;
}
input[type="time"]::-webkit-datetime-edit {
    background: transparent;
    color: transparent;
    height: 0px;
}
input[type="time"] {
    border: none;
    background: transparent;
    height: 0px;
    margin-left: 50px;
}
input[type="time"]::-webkit-calendar-picker-indicator {
    background: transparent;
    color: transparent;
    cursor: pointer;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 50vh;
    width: 90vw;
}
input[type="date"]::-webkit-datetime-edit {
    background: transparent;
    color: transparent;
    height: 0px;
}
input[type="date"] {
    border: none;
    background: transparent;
    height: 0px;
    margin-left: 50px;
}
input[type="date"]::-webkit-calendar-picker-indicator {
    background: transparent;
    color: transparent;
    cursor: pointer;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    height: 50vh;
    width: 90vw;
}
.wrapper__location {
    margin: 0;
}
</style>
